import { render, staticRenderFns } from "./RegistryDataTable.vue?vue&type=template&id=51fa1a9b&scoped=true"
import script from "./RegistryDataTable.vue?vue&type=script&lang=js"
export * from "./RegistryDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fa1a9b",
  null
  
)

export default component.exports